<div *ngIf="formInitialized">
	<div [formGroup]="formGroup">
		<div class="left-side">
			<!-- Elements for the left side -->
			<div class="row">
				<div class="form-group">

					<div class="settings-container">
						<div class="setting-description">
							<label class="form-label">Start time</label>
						</div>
						<div class="setting-field">
							<dx-date-box displayFormat="dd/MM/yyyy HH:mm" [width]="200"
								dateSerializationFormat="yyyy-MM-ddTHH:mm:ss" type="datetime" as-validator
								formControlName="startDate">
							</dx-date-box>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="form-group">

					<div class="settings-container">
						<div class="setting-description">
							<div class="left-div"><label class="form-label">Enable recurrence</label></div>
						</div>
						<div class="setting-field">
							<div class="right-div" style="position: relative; top: 1px;">
								<dx-switch class="al-switch" formControlName="isRecurring"></dx-switch>
							</div>
						</div>
					</div>
					<!-- <label class="form-label">Enable recurrence</label>
							<dx-switch class="al-switch" formControlName="isRecurring"></dx-switch> -->
				</div>
			</div>
		</div>
		<div class="right-side">
			<!-- Elements for the right side -->
			<ng-container formGroupName="recurringGroup" *ngIf="this.formGroup.controls['isRecurring'].value">
				<div class="row">
					<div class="form-group">

						<div class="settings-container">
							<div class="setting-description">
								<label class="form-label">Recurrence</label>
							</div>
							<div class="setting-field">
								<dx-select-box [width]="200" ngDefaultControl formControlName="recurrencePeriodicity"
									[(value)]="selectedPeriodicityValue" valueExpr="id" displayExpr="description"
									[dataSource]="periodicityList">
								</dx-select-box>
							</div>
						</div>

					</div>
				</div>
				<!-- Hourly -->
				<div class="row">
					<ng-container *ngIf="selectedPeriodicityValue === 1">
						<div class="form-group" formGroupName="hourlyRecurrenceGroup">
							<div class="settings-container">
								<div class="setting-description">
									<label class="form-label">Repeat every x hour(s)</label>
								</div>
								<div class="setting-field">
									<dx-number-box [width]="200" formControlName="hourlyRecurrenceEveryXHours" [min]="hourlySchedulerAllowanceHours"
										[showSpinButtons]="true" [inputAttr]="{ 'aria-label': 'Min And Max' }">
									</dx-number-box>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- Daily -->
					<ng-container *ngIf="selectedPeriodicityValue === 2">
						<div class="form-group" formGroupName="dailyRecurrenceGroup">

							<div class="settings-container">
								<div class="setting-description">
									<label class="form-label">Repeat every x day(s)</label>
								</div>
								<div class="setting-field">
									<dx-number-box [width]="200" formControlName="dailyRecurrenceEveryXDays" [min]="1"
										[showSpinButtons]="true" [inputAttr]="{ 'aria-label': 'Min And Max' }">
									</dx-number-box>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- Weekly -->
					<ng-container formGroupName="weeklyRecurrenceGroup" *ngIf="selectedPeriodicityValue === 3">
						<div class="form-group">

							<div class="settings-container">
								<div class="setting-description">
									<label class="form-label">Repeat every x week(s)</label>
								</div>
								<div class="setting-field">
									<dx-number-box [width]="200" formControlName="weeklyRecurrenceyEveryXWeeks"
										[min]="1" [showSpinButtons]="true"
										[inputAttr]="{ 'aria-label': 'Min And Max' }">
									</dx-number-box>
								</div>
							</div>
						</div>
						<div class="form-group">

							<div class="settings-container">
								<div class="setting-description">
									<label class="form-label">Repeat on</label>
								</div>
								<div class="setting-field">
									<dx-button-group [(selectedItems)]="selectedWeekdays" [items]="weekdays"
										keyExpr="id" stylingMode="outlined" selectionMode='multiple'>
									</dx-button-group>
								</div>
							</div>
						</div>

					</ng-container>
					<!-- Monthly -->
					<ng-container formGroupName="monthlyRecurrenceGroup" *ngIf="selectedPeriodicityValue === 4">
						<div class="form-group">

							<div class="settings-container">
								<div class="setting-description">
									<label class="form-label">Repeat every x months(s)</label>
								</div>
								<div class="setting-field">
									<dx-number-box [width]="200" formControlName="monthlyRecurrenceEveryXMonths"
										[min]="1" [showSpinButtons]="true"
										[inputAttr]="{ 'aria-label': 'Min And Max' }">
									</dx-number-box>
								</div>
							</div>
						</div>
						<div class="form-group">

							<div class="settings-container">
								<div class="setting-description">
									<label class="form-label">Repeat on specified day</label>
								</div>
								<div class="setting-field">
									<dx-number-box [width]="200" formControlName="monthlyRecurrenceRepeatOnDay"
										[min]="1" [showSpinButtons]="true"
										[inputAttr]="{ 'aria-label': 'Min And Max' }">
									</dx-number-box>
								</div>
							</div>
						</div>
					</ng-container>
					<!-- Yearly -->
					<ng-container *ngIf="selectedPeriodicityValue === 5">
						No support
					</ng-container>
				</div>
				<ng-container formGroupName="endRecurrence">
					<div class="row">
						<div class="form-group">
							<label class="form-label" style="font-size: 14px;font-weight: unset; padding-bottom: 5px">End recurrence</label>

							<div class="container-radio">
								<div class="radio-container">
									<dx-radio-group [items]="endtypeList" valueExpr="id" displayExpr="description"
										[(value)]="selectedEndType" formControlName="endRecurrenceType"
										(onValueChanged)="onRadioGroupValueChanged($event)">
									</dx-radio-group>
								</div>
								<div class="date-container">
									<dx-date-box formControlName="endRecurrenceDate"></dx-date-box>
									<div style="padding-top: 8px">
										<div class="itempair-container">
											<div class="itempair-element">
												<dx-number-box [width]="100" formControlName="endRecurrenceCount"
													[min]="1" [showSpinButtons]="true"
													[inputAttr]="{ 'aria-label': 'Min And Max' }">
												</dx-number-box>
											</div>
											<div class="itempair-element">
												<label class="form-label" style="padding-left: 10px;font-size: 14px;font-weight: unset;">occurrences</label>
												<!-- <label style="font-size: 16px; padding-left: 10px">
															occurences</label> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
